export interface OrderDocumentType {
  id: number;
  code: string;
  name: string;
  required: boolean;
  availableInCarrierPortal: boolean;

  externalNameForbusinessUnit: string;
}

export class OrderDocumentTypeExternal {
  id: number;
  externalName: string;
  orderDocumentTypeId: number;
}
